import { useEffect } from 'react';
import { select } from '~/lib/select';
import { GlobalMediaStore, useGlobalMediaStore } from './GlobalMediaProvider';
import { useMediaPlayerStore } from './MediaPlayerProvider';
import { MediaPlayerStore } from './MediaPlayerStore';

const selector = (s: MediaPlayerStore) => select(s, 'status', 'player');

/**
 * Called by media players to ensure the global media state is accurately keeping track
 * of the currently active player.
 */
export function useGlobalMedia() {
  const { status, player } = useMediaPlayerStore(selector);
  const thisPlayer = player();
  const globalMedia = useGlobalMediaStore() as GlobalMediaStore;

  useEffect(() => {
    if (status === 'playing') {
      globalMedia.setPlayer(thisPlayer);
    } else {
      if (globalMedia.player === thisPlayer) {
        globalMedia.setPlayer();
      }
    }
  }, [status, globalMedia.player]);
}
